import Layout from '@/layout';
var storeRouter = {
  path: '/store',
  component: Layout,
  redirect: '/store/index',
  name: 'Store',
  meta: {
    title: '商品',
    icon: 'clipboard'
  },
  children: [{
    path: 'goodsManage',
    component: function component() {
      return import('@/views/store/goodsManage');
    },
    name: 'goodsManage',
    meta: {
      title: '商品管理',
      icon: '',
      noCache: false
    },
    children: [{
      path: 'spu',
      name: 'Spu',
      component: function component() {
        return import('@/views/store/goodsManage/spu/index');
      },
      meta: {
        title: 'SPU列表',
        noCache: false
      }
    }, {
      path: 'sku',
      name: 'Sku',
      component: function component() {
        return import('@/views/store/goodsManage/sku/index');
      },
      meta: {
        title: 'SKU列表',
        noCache: false
      }
    }, {
      path: 'spu2',
      name: 'Spu2',
      component: function component() {
        return import('@/views/store/goodsManage/spu2/index');
      },
      meta: {
        title: 'SPU列表-供应商',
        noCache: false
      }
    }, {
      path: 'sku2',
      name: 'Sku2',
      component: function component() {
        return import('@/views/store/goodsManage/sku2/index');
      },
      meta: {
        title: 'SKU列表-供应商',
        noCache: false
      }
    }, {
      path: 'goodsBatch',
      name: 'goodsBatch',
      component: function component() {
        return import('@/views/store/goodsManage/goodsBatch/index');
      },
      meta: {
        title: '商品批量',
        noCache: false
      }
    }, {
      path: 'thirdSku',
      name: 'thirdSku',
      component: function component() {
        return import('@/views/store/goodsManage/thirdSku/index');
      },
      meta: {
        title: '第三方商品',
        noCache: false
      }
    }, {
      path: 'pintuanSpu',
      name: 'pintuanSpu',
      component: function component() {
        return import('@/views/store/goodsManage/pintuanSpu/index');
      },
      meta: {
        title: '拼团商品',
        noCache: false
      }
    }, {
      path: 'companySkus',
      name: 'companySkus',
      component: function component() {
        return import('@/views/store/goodsManage/companySkus/index');
      },
      meta: {
        title: '小程序商品列表',
        noCache: false
      }
    }, {
      path: 'supplierGoods',
      name: 'supplierGoods',
      component: function component() {
        return import('@/views/store/goodsManage/supplierGoods/index');
      },
      meta: {
        title: '客户商品列表',
        noCache: false
      }
    }, {
      path: 'goodsAll',
      name: 'goodsAll',
      component: function component() {
        return import('@/views/store/goodsManage/goodsAll/index');
      },
      meta: {
        title: '商品上传',
        noCache: false
      }
    }, {
      path: 'cardInventory',
      name: 'cardInventory',
      component: function component() {
        return import('@/views/store/goodsManage/cardInventory/index');
      },
      meta: {
        title: '一卡通库存管理',
        noCache: false
      }
    }, {
      path: 'cardInventory/detail/:skuId',
      name: 'cardInventoryDetail',
      component: function component() {
        return import('@/views/store/goodsManage/cardInventory/detail');
      },
      meta: {
        title: '库存详情',
        noCache: false,
        activeMenu: "/store/goodsManage/cardInventory"
      },
      hidden: true
    }, {
      path: 'cardInventory/operationLog',
      name: 'cardInventoryOperationLog',
      component: function component() {
        return import('@/views/store/goodsManage/cardInventory/operationLog');
      },
      meta: {
        title: '操作日志',
        noCache: false,
        activeMenu: "/store/goodsManage/cardInventory"
      },
      hidden: true
    }]
  }, {
    path: 'dangao',
    component: function component() {
      return import('@/views/store/dangao/index');
    },
    name: 'dangao',
    meta: {
      title: '蛋糕管理',
      icon: '',
      noCache: false
    },
    children: [{
      path: 'lists/:brandId?',
      name: 'cartLists',
      component: function component() {
        return import('@/views/store/dangao/lists/index');
      },
      meta: {
        title: '蛋糕列表',
        noCache: false
      }
    }, {
      path: 'shoplist',
      name: 'shoplist',
      component: function component() {
        return import('@/views/store/dangao/shoplist/index');
      },
      meta: {
        title: '门店管理',
        noCache: false
      }
    }, {
      path: 'shoplist/creatShop/:id',
      component: function component() {
        return import('@/views/store/dangao/shoplist/creatShop');
      },
      name: 'creatShop',
      meta: {
        title: '门店设置',
        noCache: false,
        activeMenu: "/store/dangao/shoplist"
      },
      hidden: true
    }, {
      path: 'lists/dgEdit/:id',
      component: function component() {
        return import('@/views/store/dangao/lists/dgEdit');
      },
      name: 'creatShop',
      meta: {
        title: '商品信息',
        noCache: false,
        activeMenu: "/store/dangao/lists"
      },
      hidden: true
    }, {
      path: 'brandlist',
      name: 'brandlist',
      component: function component() {
        return import('@/views/store/dangao/brandlist/index');
      },
      meta: {
        title: '品牌管理',
        noCache: false
      }
    }]
  }, {
    path: 'sort',
    component: function component() {
      return import('@/views/store/sort/index');
    },
    name: 'Sort',
    meta: {
      title: '分类管理',
      icon: '',
      noCache: false
    },
    children: [{
      path: 'ordinary',
      name: 'ordinary',
      component: function component() {
        return import('@/views/store/sort/ordinary/index');
      },
      meta: {
        title: '商品分类',
        noCache: false
      }
    }, {
      path: 'show',
      name: 'show',
      component: function component() {
        return import('@/views/store/sort/show/index');
      },
      meta: {
        title: '展示分类',
        noCache: false
      }
    }, {
      path: 'jingdongCate',
      name: 'jingdongCate',
      component: function component() {
        return import('@/views/store/sort/jingdongCate/index');
      },
      meta: {
        title: '京东分类',
        noCache: false
      }
    }]
  }, {
    path: 'attr',
    component: function component() {
      return import('@/views/store/storeAttr/index');
    },
    name: 'SortAttr',
    meta: {
      title: '商品规格',
      icon: '',
      noCache: false
    }
  }, {
    path: 'comment',
    component: function component() {
      return import('@/views/store/storeComment/index');
    },
    name: 'StoreComment',
    meta: {
      title: '商品评论',
      icon: '',
      noCache: false
    }
  }, {
    path: 'list/creatProduct/:id?/:isDisabled?',
    component: function component() {
      return import('@/views/store/creatStore/index');
    },
    name: 'SortCreat',
    meta: {
      title: '商品添加',
      noCache: false,
      activeMenu: "/store/index"
    },
    hidden: true
  }, {
    path: 'list/creatProduct2/:id?/:isDisabled?',
    component: function component() {
      return import('@/views/store/creatStore2/index');
    },
    name: 'SortCreat',
    meta: {
      title: '商品添加-供应商',
      noCache: false,
      activeMenu: "/store/index"
    },
    hidden: true
  }, {
    path: 'list/creatPintuan/:id?/:isDisabled?/:spuid',
    component: function component() {
      return import('@/views/store/creatPintuan/index');
    },
    name: 'SortCreat',
    meta: {
      title: '拼团商品配置',
      noCache: false,
      activeMenu: "/store/goodsManage/pintuanSpu"
    },
    hidden: true
  }, {
    path: 'brand',
    name: 'brand',
    component: function component() {
      return import('@/views/store/storeBrand/index');
    },
    meta: {
      title: '品牌管理',
      icon: '',
      noCache: false
    }
  }, {
    path: 'goodsTag',
    name: 'goodsTag',
    component: function component() {
      return import('@/views/store/goodsTag/index');
    },
    meta: {
      title: '商品标签',
      icon: '',
      noCache: false
    }
  }, {
    path: 'goodsNameTag',
    name: 'goodsNameTag',
    component: function component() {
      return import('@/views/store/goodsNameTag/index');
    },
    meta: {
      title: '商品名称标签',
      icon: '',
      noCache: false
    }
  }, {
    path: 'employeeCompanyTag',
    name: 'employeeCompanyTag',
    component: function component() {
      return import('@/views/store/employeeCompanyTag/index');
    },
    meta: {
      title: '员工归属公司标签',
      icon: '',
      noCache: false
    }
  }, {
    path: 'platformCard',
    name: 'platformCard',
    component: function component() {
      return import('@/views/store/platformCard/index');
    },
    meta: {
      title: '自营卡券库存管理',
      icon: '',
      noCache: false
    }
  }, {
    path: 'platformCard/storeDetails/:id?',
    component: function component() {
      return import('@/views/store/platformCard/storeDetails');
    },
    meta: {
      title: '自营卡券库存详情',
      icon: '',
      noCache: false
    }
  }, {
    path: 'goodsChannel',
    name: 'goodsChannel',
    component: function component() {
      return import('@/views/store/goodsChannel/index');
    },
    meta: {
      title: '商品频道',
      icon: '',
      noCache: false
    }
  }, {
    path: 'goodsCard',
    name: 'goodsCard',
    component: function component() {
      return import('@/views/store/goodsCard/index');
    },
    meta: {
      title: '福卡列表',
      icon: '',
      noCache: false
    }
  }, {
    path: 'sj_stopCarCard',
    name: 'sj_stopCarCard',
    component: function component() {
      return import('@/views/store/sj_stopCarCard/index');
    },
    meta: {
      title: '停车卡管理',
      icon: '',
      noCache: false
    }
  }, {
    path: 'sj_stopCarPark',
    name: 'sj_stopCarPark',
    component: function component() {
      return import('@/views/store/sj_stopCarPark/index');
    },
    meta: {
      title: '停车场管理',
      icon: '',
      noCache: false
    }
  }]
};
export default storeRouter;